import('./parts')
import('./modules')

require('./components/backToTop.js')
require('./components/hamburger.js')
// require("./components/fancybox.js");
